import { render, staticRenderFns } from "./fee-standards-list.vue?vue&type=template&id=f155ec66&scoped=true&"
import script from "./fee-standards-list.vue?vue&type=script&lang=js&"
export * from "./fee-standards-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f155ec66",
  null
  
)

export default component.exports